const today = new Date();
const isoDate = (offsetDays) => {
  const date = new Date(today);
  date.setDate(today.getDate() + offsetDays);
  return date.toISOString().slice(0, 10);
};

export const demoDepartments = [
  { DepartmentID: 1, name: "Service", shorthand_symbol: "SVC", color_hex: "#1ACCA9" },
  { DepartmentID: 2, name: "Kitchen", shorthand_symbol: "KIT", color_hex: "#F97316" },
  { DepartmentID: 3, name: "Bar", shorthand_symbol: "BAR", color_hex: "#6366F1" },
];

export const demoShifts = [
  { ShiftID: 1, name: "Morning", shorthand_symbol: "M", start_time: "07:00", end_time: "15:00", color_hex: "#1ACCA9" },
  { ShiftID: 2, name: "Evening", shorthand_symbol: "E", start_time: "15:00", end_time: "23:00", color_hex: "#6366F1" },
  { ShiftID: 3, name: "Split", shorthand_symbol: "SP", start_time: "11:00", end_time: "20:00", color_hex: "#F97316" },
];

export const demoUsers = [
  "Mia Keller",
  "Noah Fischer",
  "Lina Weber",
  "Elias Meier",
  "Sofia Schneider",
  "Luca Huber",
  "Emma Braun",
  "Leon Wagner",
  "Nina Hofmann",
  "Ben Richter",
  "Laura Schmid",
  "Finn Wolf",
  "Anna Becker",
  "Tim Koch",
  "Sara Neumann",
].map((name, index) => {
  const [first_name, last_name] = name.split(" ");
  return {
    UserID: index + 1,
    first_name,
    last_name,
    email: `${first_name.toLowerCase()}.${last_name.toLowerCase()}@demo.timetab.ch`,
    employment: index % 4 === 0 ? "Temp" : "Perm",
    employment_level: index % 3 === 0 ? 0.6 : 1.0,
  };
});

export const demoTimetableEvents = Array.from({ length: 21 }, (_, index) => {
  const user = demoUsers[index % demoUsers.length];
  const shift = demoShifts[index % demoShifts.length];
  const department = demoDepartments[index % demoDepartments.length];
  return {
    TimetableID: index + 1,
    UserID: user.UserID,
    user_name: `${user.first_name} ${user.last_name}`,
    ShiftID: shift.ShiftID,
    shift_name: shift.name,
    DepartmentID: department.DepartmentID,
    department_name: department.name,
    date: isoDate(index % 7),
    start_time: shift.start_time,
    end_time: shift.end_time,
    color_hex: department.color_hex,
  };
});

export const demoCompany = {
  name: "TimeTab Demo Company",
  departments: demoDepartments,
  shifts: demoShifts,
  users: demoUsers,
  timetableEvents: demoTimetableEvents,
};
